var _a, _b;
import { __assign } from "tslib";
import { handleActions } from 'redux-actions';
import { openUserDropdown, closeUserDropdown, openNotificationsDropdown, closeNotificationsDropdown, toggleSubmitMenu, openSearchModal, closeSearchModal, toggleSearchModal, showPortfolioTooltip, hidePortfolioTooltip, siteHeaderSearchButtonClicked, toggleBurgerMenuRequested, userLogoutButtonClicked, toggleFeedbackPage, } from './actions';
import { reduxKey } from './constants';
export var initialState = {
    isSearchModalShown: false,
    isUserDropdownOpen: false,
    isBurgerMenuOpen: false,
    isPortfolioTooltipShown: false,
    isNotificationsDropdownOpen: false,
    isSubmitMenuOpen: false,
    isLoggingOut: false,
};
var actionHandlers = handleActions((_a = {},
    _a[openSearchModal.toString()] = function (state) { return (__assign(__assign({}, state), { isSearchModalShown: true, isUserDropdownOpen: false, isNotificationsDropdownOpen: false })); },
    _a[closeSearchModal.toString()] = function (state) { return (__assign(__assign({}, state), { isSearchModalShown: false })); },
    _a[toggleSearchModal.toString()] = function (state) { return (__assign(__assign({}, state), { isSearchModalShown: !state.isSearchModalShown })); },
    _a[siteHeaderSearchButtonClicked.toString()] = function (state) { return (__assign(__assign({}, state), { isUserDropdownOpen: false, isNotificationsDropdownOpen: false })); },
    _a[openUserDropdown.toString()] = function (state) { return (__assign(__assign({}, state), { isUserDropdownOpen: true, isNotificationsDropdownOpen: false })); },
    _a[closeUserDropdown.toString()] = function (state) { return (__assign(__assign({}, state), { isUserDropdownOpen: false })); },
    _a[showPortfolioTooltip.toString()] = function (state) { return (__assign(__assign({}, state), { isPortfolioTooltipShown: true })); },
    _a[hidePortfolioTooltip.toString()] = function (state) { return (__assign(__assign({}, state), { isPortfolioTooltipShown: false })); },
    _a[openNotificationsDropdown.toString()] = function (state) {
        return __assign(__assign({}, state), { isNotificationsDropdownOpen: true, isUserDropdownOpen: false });
    },
    _a[closeNotificationsDropdown.toString()] = function (state) { return (__assign(__assign({}, state), { isNotificationsDropdownOpen: false })); },
    _a[toggleFeedbackPage.toString()] = function (state) { return (__assign(__assign({}, state), { isNotificationsDropdownOpen: false })); },
    _a[toggleSubmitMenu.toString()] = function (state) {
        var isOpen = !state.isSubmitMenuOpen;
        return __assign(__assign({}, state), { isSubmitMenuOpen: isOpen });
    },
    _a[toggleBurgerMenuRequested.toString()] = function (state, _a) {
        var isOpenAfter = _a.payload.isOpenAfter;
        return (__assign(__assign({}, state), { isBurgerMenuOpen: isOpenAfter !== null && isOpenAfter !== void 0 ? isOpenAfter : !state.isBurgerMenuOpen }));
    },
    _a[userLogoutButtonClicked.toString()] = function (state) { return (__assign(__assign({}, state), { isLoggingOut: true })); },
    _a), initialState);
export default (_b = {},
    _b[reduxKey] = actionHandlers,
    _b);
//# sourceMappingURL=reducer.js.map